import React  from 'react'
import { FooterPortal } from './Content/pages/FooterDesktop'
import { FooterSimple } from './Content/pages/FooterSimple'

export function Footer(props){
    const {
        type
    } = props

    return(
        type === 'complete'
            ?
                <FooterPortal visible={null} />
            :
                type === 'simple'
                    ?
                        <FooterSimple />
                    : null
    )
} 